import React from 'react'
import { SpotlightModule } from '@scentregroup/shared/components/spotlight-v2'
import {
  SGPageTemplateContentAnalyticsMetadata,
  SGPageTemplateContentCollection,
  SGPageTemplateContentEntry,
  SGPageTemplateDisplayAnalyticsMetadata,
} from '../../../../../../src/types/page-templates'
import { ModuleProps } from '../../types'

const convertItemsToEntries = (
  items: SGPageTemplateContentEntry[]
): SpotlightEntriesProps[] =>
  items.map(item => ({
    analyticsMetadata: item.analyticsMetadata,
    contentTypeId: item.kind,
    desktopImageUrl: item.image.url,
    mobileImageUrl: item.secondaryImage
      ? item.secondaryImage.url
      : item.image.url,
    link: item.callToAction.url,
    title: item.title,
  }))

export interface SpotlightEntriesProps {
  analyticsMetadata?: SGPageTemplateContentAnalyticsMetadata
  contentTypeId: string
  desktopImageUrl: string
  mobileImageUrl: string
  link: string
  title: string
}

export interface SpotlightModuleProps {
  heading?: string
  color?: string | null
  analyticsMetadata?: SGPageTemplateDisplayAnalyticsMetadata
  callToAction: {
    text?: string
    address?: string
    eventCategory?: string
    eventAction?: string
    eventLabel?: string
  }
  title?: string
  shortDescription: string
  entries: SpotlightEntriesProps[]
}

export default function SGPageTemplateContentCollectionSpotlightModule({
  module,
}: ModuleProps<SGPageTemplateContentCollection>): JSX.Element | null {
  const moduleV2ToV1: SpotlightModuleProps = {
    analyticsMetadata: module.analyticsMetadata,
    title: module.title || '',
    shortDescription: module.shortDescription || '',
    callToAction: {
      text: module.callToAction?.label,
      address: module.callToAction?.url,
    },
    entries: convertItemsToEntries(module.items),
  }
  return <SpotlightModule moduleProps={moduleV2ToV1} />
}
